export default __webpack_public_path__ + "static/icon-factories-e4fb171a41b3d807feff39157591fc12.svg";